import { useQuery } from '@tanstack/react-query'
import { API_URL } from '../const'
import { Provincia } from '../types'
import axios from 'axios'
import { serializeQueryParams } from './utils'

export async function getProvince(
  geocontext: number | undefined,
  params: Record<string, any> = {},
  signal?: AbortSignal
) {
  return (
    await axios.get(`${API_URL}/geo-contexts/${geocontext}/provinces/`, {
      signal,
      params: serializeQueryParams(params),
    })
  ).data as Provincia[]
}

export function useProvince(
  geocontext: number | undefined,
  params: Record<string, any> = {}
) {
  return useQuery({
    queryKey: ['province', geocontext, params],
    queryFn: ({ signal }) => getProvince(geocontext!, params, signal),
    keepPreviousData: true,
    suspense: false,
    enabled: !!geocontext && (!!params.q || !!params.id),
  })
}

export function useProvinciaById(
  geocontext: number | undefined,
  id: number | undefined
) {
  return useQuery({
    queryKey: ['provincia', geocontext, id],
    queryFn: ({ signal }) =>
      getProvince(geocontext!, { id }, signal).then((province) => province[0]),
    keepPreviousData: true,
    suspense: false,
    enabled: !!geocontext && !!id,
  })
}